export default __webpack_public_path__ + "static/media/ritesh.99c278ef.png";